import Stack from "@mui/material/Stack";
import { PatientProfile, Task } from "src/api/types";
import TaskWrapper from "src/wrappers/TaskWrapper";
import { useWaitingRoom } from "src/context/WaitingRoomProvider/useWaitingRoom";
import TextMessagesList from "../SmsMessaging/components/TextMessages";
import NewSmsMessageForm from "../SmsMessaging/components/NewSmsMessageForm";

interface Props {
  patient: PatientProfile;
  task: Task;
  onSuccess: () => void;
}

const UnreadTextMessageTask = ({ task, patient, onSuccess }: Props) => {
  const forwardingReason = useWaitingRoom((room) => room.forwarding_reason);

  return (
    <TaskWrapper task={task} forwardingReason={forwardingReason || ""}>
      <Stack
        height="100%"
        sx={{ overflowY: "auto", background: "white", borderRadius: "10px" }}
      >
        <TextMessagesList patient={patient} />
        <NewSmsMessageForm
          phoneNumber={patient.profile.phone_number}
          onSuccess={onSuccess}
          patientProfileId={patient.profile_id}
        />
      </Stack>
    </TaskWrapper>
  );
};

export default UnreadTextMessageTask;
